import React from 'react';

import {ListTheme} from './ListTheme.jsx';
import {ListPlus} from './ListPlus.jsx';
import {ListThemeShared} from './ListThemeShared.jsx';

var ListView = React.createClass({
	makeActive: function(slug){
		this.props.makeActive(slug);
	},
  showPreview: function(user, slug){
    this.props.showPreview(user, slug);
  },
  editTheme: function(slug, accountSlug, type){
    this.props.editTheme(slug, accountSlug, type);
  },
  popup: function(value){
    // this.props.popup(value); // for opens popup when click on activate
  },
  clone: function(action, accountSlug, slug){
      this.props.clone(action, "", "", accountSlug, slug);
  },
  browse: function(slug) {
    this.props.browse(slug);
  },
	render: function(){
  	return(
      	<div className="theme-container clearfix list--container">
          { this.props.libName === "Shared with me" || this.props.libName === "My Purchases" || this.props.libName === "Archived Packages" ?
            <ListThemeShared    themes = {this.props.themes}
                                showPreview = {this.showPreview}
                                libName = {this.props.libName}
                                clone = {this.clone}
                                browse = {this.browse}
                                editTheme = {this.editTheme} /> :
            <div>
              <ListTheme  themes = {this.props.themes} 
                          makeActive= {this.makeActive} 
                          showPreview = {this.showPreview} 
                          editTheme = {this.editTheme}
                          libName = {this.props.libName}
                          active = {this.props.active}
                          popup = {this.popup} />
              <ListPlus />   
            </div> }
      	</div>
      );
	}
});

export{ListView};


/** WEBPACK FOOTER **
 ** ./html/components/ListView.jsx
 **/